import { eventsTable } from '@/controllers/events-table'
import { reports } from '@/controllers/events'

const [route, action] = ['reports', 'record']

export const getReportRecordById = function (recordId, callback) {
  window[Symbol.for('vue.prototype')].$sendMessageToWorker({ route, action, recordId })

  eventsTable[reports[action]] = callback
}
